module.exports = __webpack_public_path__ + "img/HINDU PURPLE.074e060.svg";